module.exports = {
  LMS_BASE_URL: "http://localhost:18000",
  LOGIN_URL: "http://localhost:18000/login",
  LOGOUT_URL: "http://localhost:18000/logout",
};
